import React from 'react';
import Home from './pages/Home';
import './assets/styles/index.scss';

const App = () => {
  return (
    <div className="root">
      <Home />
    </div>
  );
};

export default App;